import React from "react";
import AttendanceCell from "./AttendanceCell";
import { ATTENDANCE_LEGEND_ITEMS } from "./attendanceHelpers";
import { Space } from "antd";

const AttendanceLegend = () => (
	<Space size="middle" wrap className="attendance-legend">
		{ATTENDANCE_LEGEND_ITEMS.map((item) => (
			<span
				key={item.label}
				style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
				<AttendanceCell
					cell={item.cell || { status: item.status }}
				/>
				{item.label}
			</span>
		))}
	</Space>
);

export default AttendanceLegend;
